import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, Output } from '@angular/core';
import { WtfAnimations } from '../../../../utils/others/core/animations';


@Component({
    selector     : 'wtf-profile',
    templateUrl  : './profile.component.html',
    styleUrls    : ['./profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : WtfAnimations
})
export class ProfileComponent implements OnInit
{
    // Set Template Parameters
    @Input() layout: string;        //  simple | carded
    @Input() pagelayout: string;

    @Input() profileImage: string;
    @Input() profileName: string;
    @Input() isCustomer: boolean;

    @Output() onClickProfileImage = new EventEmitter<void>();

    constructor()
    {
        this.layout = 'simple';
    }


    ProfileImageClick(){
        this.onClickProfileImage.emit();
    }


    ngOnInit()
    {
        /**SET THE DEFAULT PAGE LAYOUT AS SIMPLE */

        this.pagelayout = 'page-layout ' + this.layout + ' fullwidth';
        this.profileName = 'My Profile Name';
    }
}
